var _path, _path2, _path3, _polygon, _path4, _polygon2, _path5, _polygon3, _path6, _path7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDiaperCream = function SvgDiaperCream(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICONS",
    viewBox: "0 0 606.27 613.33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.62,226.93s0,0,0,0c0,0,0,0,0,0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.25,489.73c-34.87-.09-69.74-.02-104.61,.01h109.17c-1.52,0-3.04,0-4.57-.01Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M510.07,448.5c-2.35,1.7-4,4.09-4.99,6.77,1-2.68,2.66-5.07,4.99-6.77Z",
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "120.64 489.74 70.92 489.74 70.92 510.77 246.5 510.77 246.5 489.74 246.03 489.74 229.81 489.74 120.64 489.74",
    fill: "#fdb73e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.15,521.42c0,9.45-7.66,17.11-17.11,17.11h-32.13c-9.45,0-17.11-7.66-17.11-17.11v-.08h-59.9v9.95c0,14.19,11.5,25.69,25.69,25.69h124.21c14.19,0,25.69-11.5,25.69-25.69v-9.95h-49.35v.08Z",
    fill: "#fdb73e"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "70.92 510.89 70.92 519.67 70.92 521.35 130.82 521.35 130.82 520.73 197.15 520.73 197.15 521.35 246.5 521.35 246.5 519.67 246.5 510.89 246.5 510.77 70.92 510.77 70.92 510.89",
    fill: "#6ab4e5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.92,538.53h32.13c9.45,0,17.11-7.66,17.11-17.11v-.69h-66.34v.69c0,9.45,7.66,17.11,17.11,17.11Z",
    fill: "#015e85"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "70.92 489.74 27.67 74.71 295.92 74.71 246.5 489.74 70.92 489.74",
    fill: "#f4abe0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295.38,335.1h267.58v193.42c0,17.11-13.89,31-31,31h-205.58c-17.11,0-31-13.89-31-31v-193.42h0Z",
    fill: "#6ab4e5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.38,274.96h217.58c13.8,0,25,11.2,25,25v37.3H295.38v-37.3c0-13.8,11.2-25,25-25Z",
    fill: "#fdb73e"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiaperCream, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diaper_cream.1a218096.svg";
export { ForwardRef as ReactComponent };